////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'

//////STYLED//////
const KioskDiagnosticStatusWrapper = styled.div`
	& > div {
		width: 20px;
		height: 20px;
		background-color: ${(props) => {
			switch (props.level) {
				case 1:
				case 5:
				case 6:
					return props.theme.colors.cancel
				case 2:
				case 4:
				case 7:
					return props.theme.colors.warning
				case 3:
					return props.theme.colors.error
				default:
					return props.theme.colors.cancel
			}
		}};
		border-radius: 10px;
		margin: auto;
	}
`
//////STYLED//////

const KioskDiagnosticStatus = ({ level }) => {
	return (
		<KioskDiagnosticStatusWrapper level={level}>
			<div />
		</KioskDiagnosticStatusWrapper>
	)
}

KioskDiagnosticStatus.propTypes = {}

KioskDiagnosticStatus.defaultPropTypes = {}

export default KioskDiagnosticStatus
